<a [routerLink]="href">
  <motn-image-card
    [title]="app.Name"
    [subtitle]="$safeNavigationMigration(app.Config?.Subtitle?.Text)"
    [imgSrc]="imgSource"
  ></motn-image-card>
</a>
